import { EntityUtils } from '@record-it-npm/synchro-client';
import { User } from './userTypes';
export class UserUtils {
  private constructor() {}
  public static displayTextGetter = (user: User): string => user.name;
  public static keyGetter = (user: User): string => EntityUtils.getTrackingKey(user);
}